import { styled } from '@mui/material';
import styles, { drawerMiniWidth, drawerWidth, rightDrawerWidth } from 'assets/jss/styles';
import { includes } from 'ramda';

export const Container = styled('div')(({ theme }) => ({
  ...styles(theme)?.defaultFont,
  backgroundColor: theme.palette.background.default,
  color: theme.palette.primary.main,
  // backgroundColor: theme.palette.bg.main,
  // color: theme.palette.activeColor,
  // fontFamily: theme.typography.fontFamily,
  // fontSize: theme.typography.fontSize,
  position: 'relative',
  top: '0',
  height: '100vh',
  '&:after': {
    display: 'table',
    clear: 'both',
    content: '""'
  }
}));

export const Content = styled('div', {
  shouldForwardProp: prop => !includes(prop, ['drawerMinimized', 'rightSideOpened'])
})(({ theme, drawerMinimized, rightSideOpened }) => ({
  [theme.breakpoints.up('md')]: {
    width: `calc(100% - ${styles(theme)?.drawerWidth}px)`
  },
  overflow: 'auto',
  overflowX: 'hidden',
  position: 'relative',
  float: 'right',
  maxHeight: '100%',
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  scrollbarGutter: 'stable',
  overflowScrolling: 'touch',
  ...(!drawerMinimized && {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${styles(theme)?.drawerMiniWidth}px)`
    }
  }),
  ...(rightSideOpened && {
    marginRight: rightDrawerWidth,
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${(!drawerMinimized ? drawerMiniWidth : drawerWidth) + rightDrawerWidth}px)`
    }
  })
}));
